import styled from 'styled-components';

const Wrapper = styled.div`
  .action-button {
    text-align: center;
    gap: 8px;
    font-size: 13px;
    background: ${(props) => props.theme.colors.outline};
    border-radius: 12px;
    padding: 10px 40px;
    margin-top: 12px;
    &:hover {
      color: ${(props) => props.theme.colors.main_cta};
    }
  }

  .unassign-btn {
    position: absolute;
    top: 16px;
    right: 16px;
    border: none;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    opacity: 0.3;
    transition: opacity 0.3s;

    &:hover {
      opacity: 0.8;
    }
  }
`;

export default { Wrapper };
